module.exports = __webpack_public_path__ + "img/img3.30a00d60.png";